import {Pipe, PipeTransform} from '@angular/core';
import {LocalizationService} from '../../services/localization/localization.service';

@Pipe({
  name: 'currencySymbolFormat',
  pure: false
})
export class CurrencySymbolFormat implements PipeTransform {
  constructor( private _localizationService: LocalizationService) {}

  transform(
      value: any,
      currencySign: string = '$',
      decimalLength: number = 2,
      chunkDelimiter?: string,
      decimalDelimiter?: string,
      chunkLength: number = 3,
      neutral = false,
      noDecimalIfZero: boolean = false
  ): string {
    chunkDelimiter = this._localizationService.localeData.currency.thousandSeparator
    decimalDelimiter = this._localizationService.localeData.currency.decimalSeparator
    if (currencySign !== '') {
      currencySign = ((currencySign === '$' && !neutral) || currencySign == null)
      && this._localizationService.localeData ? this._localizationService.localeData.currency.symbol
          : currencySign;
    }
    let auxDecimalLength = (decimalLength > 0) ? decimalLength : 1;
    if (value != null) {
      let result =
          '\\d(?=(\\d{' +
          chunkLength +
          '})+' +
          ('\\D') +
          ')';
      let num = parseFloat(value.toString()).toFixed(
          // tslint:disable-next-line:no-bitwise
          Math.max(0, ~~auxDecimalLength)
      );

      if (noDecimalIfZero) {
        num = num.replace(/[.,]0+$/, '');
      }

      let rta = currencySign + ' ' +
          (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(
              new RegExp(result, 'g'),
              '$&' + chunkDelimiter
          );
      return (decimalLength > 0) ? rta : rta.substring(0, rta.indexOf(decimalDelimiter));

    } else {
      return '';
    }
  }
}
